import { SET_ICON_BADGE_NUMBER } from './constants';

export default iconBadgeNumber => {
  if (window.isNativeApp && typeof window.postMessage === 'function') {
    console.log(SET_ICON_BADGE_NUMBER + `: ${iconBadgeNumber}`);
    window.postMessage(JSON.stringify({ type: SET_ICON_BADGE_NUMBER, payload: { iconBadgeNumber } }));
  }
};
